import { createContext, useContext } from 'react';

export type ClaimReviewLayoutState = {
    detailsExpanded: boolean;
    setDetailsExpanded: (expanded: boolean) => void;
    appHeaderId: string;
    claimDetailsId: string;
    navigationId: string;
};

export const ClaimReviewLayoutContext =
    createContext<ClaimReviewLayoutState | null>(null);

export const useClaimReviewLayout = () => useContext(ClaimReviewLayoutContext);
